import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold">琪琪影院</span>
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed">
              高清影视蓝光画质在线观看平台，不缓冲播放技术带来流畅观影体验，海量影视资源即时点播。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-gray-300">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-gray-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/全部" className="text-sm text-gray-400 hover:text-primary-400 transition-colors whitespace-nowrap">分类浏览</Link></li>
              <li><Link to="/about" className="text-sm text-gray-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-gray-300">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/动作片" className="text-sm text-gray-400 hover:text-primary-400 transition-colors whitespace-nowrap">动作片</Link></li>
              <li><Link to="/category/科幻片" className="text-sm text-gray-400 hover:text-primary-400 transition-colors whitespace-nowrap">科幻片</Link></li>
              <li><Link to="/category/喜剧片" className="text-sm text-gray-400 hover:text-primary-400 transition-colors whitespace-nowrap">喜剧片</Link></li>
              <li><Link to="/category/电视剧" className="text-sm text-gray-400 hover:text-primary-400 transition-colors whitespace-nowrap">电视剧</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-gray-300">联系方式</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-mail-line text-base"></i>
                <span>contact@qiqicinema.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-wechat-line text-base"></i>
                <span>qiqicinema2026</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            &copy; {currentYear} 琪琪影院 QIQICINEMA.COM 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-gray-500 hover:text-gray-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-gray-500 hover:text-gray-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-gray-500 hover:text-gray-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}